import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import axios from '~/data/http/axios'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Icons from '~/Common-Objects/UI/Icons/index'
import UpsellModal from '~/Common-Objects/UpsellModal'
import './index.scss'
import { alterFullpage } from '~/data/actions/siteActions'

export default function SmsUpsell({ writeAccess = true, refresh = () => {} }) {
    const account = useSelector((state) => state.accountMaster)
    const [plans, setPlans] = useState(null)
    const dispatch = useDispatch()

    const upsell = () => {
        const modal = (
            <UpsellModal
                feature='sms'
                plans={plans}
                onUpgrade={() => {
                    dispatch(alterFullpage(null))
                    refresh()
                }}
            />
        )
        dispatch(alterFullpage(modal))
    }

    useEffect(() => {
        axios.get('/accountMaster/plan?type=2').then((res) => setPlans(res.data.Plans))
    }, [])

    if (!plans?.length) return null

    const cheapestPlan = plans.reduce((prev, curr) => {
        return prev.friendlyPriceRaw < curr.friendlyPriceRaw ? prev : curr
    })

    let price = cheapestPlan.friendlyPriceRaw
    if (account.accountMaster.billingFrequency === 1) {
        price *= 12
    }

    return (
        <div className='smsUpsell'>
            <img className='hide-xs' src='https://cdn1.ourmailsender.com/siteContent/assets/upsell/sms-addon-1.png' />
            <div className='smsUpsell_content'>
                <div className='smsUpsell_header'>SMS Add-On</div>
                <div className='smsUpsell_subheader'>
                    Send targeted SMS campaigns alongside your emails and socials. Perfect for time-sensitive offers,
                    appointment reminders, and automated messages.
                </div>
                <div className='smsUpsell_checklist'>
                    <Feature>Send personalised, targeted messages</Feature>
                    <Feature>Real-time delivery and link tracking</Feature>
                    <Feature>Built-in opt-out and compliance</Feature>
                    <Feature>Seamlessly integrate into your existing Automations</Feature>
                </div>
                <Button
                    className='button-sml button-primary'
                    iconLeft={<Icons icon='plus' />}
                    disabled={!writeAccess}
                    onClick={upsell}
                    tooltip={
                        !writeAccess &&
                        `<div style="text-align:center">
                                You do not have access to manage your ${site.siteName} subscription.
                                <br />
                                Please contact your account admin.
                            </div>`
                    }
                    for='smsUpsell'
                    postHogTag='sms-subscription-add'
                >
                    Add SMS from {cheapestPlan.symbol}
                    {price}/{account.accountMaster.billingFrequency === 0 ? 'month' : 'year'}
                </Button>
            </div>
        </div>
    )
}

function Feature({ children }) {
    return (
        <div className='quickFlex forceFlex' style={{ gap: 6, alignItems: 'center' }}>
            <Icons icon='tickCircle' color='var(--site-primary)' style={{ height: 16, width: 16 }} />
            <div className='featureName'>{children}</div>
        </div>
    )
}
